import React from 'react'

function DragAndDrop() {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('text/plain', e.target.id)
    e.dataTransfer.effectAllowed = 'move'
  }

  const handleDrag = (e) => {
    e.target.style.opacity = '0.4'
  }

  const handleDragEnd = (e) => {
    e.target.style.opacity = '1'
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const id = e.dataTransfer.getData('text/plain')
    const draggableElement = document.getElementById(id)
    const dropzone = e.target
    dropzone.appendChild(draggableElement)
    e.dataTransfer.clearData()
  }

  return (
    <>
      <div draggable={true}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragEnd={handleDragEnd}
        onDragOver={handleDragOver}
        id="drag1"

      >This element is draggable</div>
      <div draggable={true}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragEnd={handleDragEnd}
        onDragOver={handleDragOver}
        id="drag2"

      >This element is draggable</div>



      <div className='d-flex'>
        <div id="drop1" onDrop={handleDrop} onDragOver={handleDragOver}>Drop here</div>
        <div id="drop2" onDrop={handleDrop} onDragOver={handleDragOver}>Drop here</div>

      </div>


    </>
  )
}

export default DragAndDrop